import { IconButton, Space, Text, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentTitle } from '@features/invoices/utils/getInvoiceDocumentTitle'

import { ModalId } from '../../../../../../../../../../../../enums/modalId'
import { useInvoiceEditorForm } from '../../../../../../../../contexts/invoiceEditorFormContext'
import { useIsInvoiceEditorElementRestricted } from '../../../../../../../../hooks/useIsInvoiceEditorElementRestricted'
import { useQuoteNumber } from '../../contexts/quoteNumberContext'
import { QuoteNumberModal } from './elements/QuoteNumberModal'
import * as Styled from './styles'

const QuoteNumberModalId = ModalId.InvoiceEditorQuoteNumberModal

export const QuoteNumber = (): ReactElement => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { open: openQuoteNumberModal } = useModal(QuoteNumberModalId)
  const { registeredQuoteNumber } = useQuoteNumber()
  const isQuoteNumberEditHidden = useIsInvoiceEditorElementRestricted('invoiceNumber', 'hidden')

  const { watch } = invoiceEditorForm

  const invoiceLanguage = watch('language')
  const documentTitle = getInvoiceDocumentTitle({
    documentType: InvoiceDocumentType.Quote,
    language: invoiceLanguage,
    t,
  })
  const invoiceTitle = `${documentTitle} - ${registeredQuoteNumber}`

  const handleEditIconClick = useCallback(() => {
    openQuoteNumberModal()
    trackInvoiceEditor('Form - Quote number clicked')
  }, [openQuoteNumberModal, trackInvoiceEditor])

  return (
    <>
      <Styled.TitleWrapper>
        <Text nowrap truncate uppercase variant="h4" weight="bold">
          {invoiceTitle}
        </Text>
        {!isQuoteNumberEditHidden && (
          <>
            <Space horizontal size="s4" />
            <IconButton icon="squarePen" onClick={handleEditIconClick} size="md" />
          </>
        )}
      </Styled.TitleWrapper>
      <QuoteNumberModal id={QuoteNumberModalId} />
    </>
  )
}
